import { render, staticRenderFns } from "./nutrientType.vue?vue&type=template&id=4fdbfecf&scoped=true&"
import script from "./nutrientType.vue?vue&type=script&lang=js&"
export * from "./nutrientType.vue?vue&type=script&lang=js&"
import style0 from "./nutrientType.vue?vue&type=style&index=0&id=4fdbfecf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbfecf",
  null
  
)

export default component.exports